import katex from 'katex';
import 'katex/contrib/mhchem';
import type { FC } from 'react';
import { useEffect, useLayoutEffect, useRef } from 'react';
import { getCdnHost, isBuildIn } from '../build-in';
import { cx } from '../cx';
import { ResourceLoader } from '../utils/resource-loader';
import './latex.css';

export const latexRender = (value: string, element?: HTMLElement | null) => {
  let errorMsg = '';
  if (!element) {
    try {
      katex.renderToString(value, {
        output: 'html',
        displayMode: true,
        throwOnError: true,
      });
    } catch (e: any) {
      errorMsg = `${e.message}`.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    return { errorMsg };
  }
  try {
    katex.render(value, element, {
      output: 'html',
      displayMode: true,
      throwOnError: true,
      strict: false,
    });
  } catch (e: any) {
    errorMsg = e?.message
      ? `${e.message}`.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      : '公式错误';
  }

  return {
    errorMsg,
  };
};

// 创建全局 KaTeX CSS 加载器
const katexCssUrls = isBuildIn()
  ? [
      'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css',
      `https://${getCdnHost()}emoji/katex.min.css`,
    ]
  : [
      'https://lib.baomitu.com/KaTeX/0.16.9/katex.min.css',
      'https://cdn2.flowus.cn/emoji/katex.min.css',
    ];

const katexCssLoader = new ResourceLoader(katexCssUrls, 'style');

export const LatexComponent: FC<{
  className?: string;
  inline?: boolean;
  text?: string;
  onClick?: () => void;
  onRender?: (error: string) => void;
  children?: React.ReactNode;
}> = (props) => {
  const divRef = useRef<HTMLDivElement>(null);
  const { className, text = '', onClick, onRender, inline } = props;

  // 动态加载 KaTeX CSS
  useEffect(() => {
    katexCssLoader.load().catch((err) => {
      console.error('KaTeX CSS加载失败:', err);
    });
  }, []);

  useLayoutEffect(() => {
    const { errorMsg } = latexRender(text, divRef.current);
    onRender?.(errorMsg);
  }, [onRender, text]);

  return (
    <span className={cx(className, 'latex-workround')} onClick={onClick}>
      {inline ? <span ref={divRef} className="inline-latex inline-block" /> : <div ref={divRef} />}
      {props.children}
    </span>
  );
};
